import React from "react";

export function MatchupCard({ matchup }) {
  const home = matchup?.home ?? "TBD";
  const away = matchup?.away ?? "TBD";
  const ptsHome = typeof matchup?.homePoints === "number" ? matchup.homePoints : null;
  const ptsAway = typeof matchup?.awayPoints === "number" ? matchup.awayPoints : null;

  const hasScore = ptsHome !== null && ptsAway !== null;
  const homeWin = hasScore && ptsHome > ptsAway;
  const awayWin = hasScore && ptsAway > ptsHome;

  return (
    <div className="matchup-card">
      {/* Home */}
      <div style={{ textAlign: "left" }}>
        <div className="matchup-team" style={{ color: homeWin ? "var(--gold)" : "var(--text)" }}>
          {home}
        </div>
        {hasScore && (
          <div style={{ fontSize: 11, color: "var(--text-dim)", marginTop: 2 }}>
            {homeWin ? "✓ WIN" : awayWin ? "LOSS" : "TIE"}
          </div>
        )}
      </div>

      {/* Score */}
      <div style={{ textAlign: "center" }}>
        {hasScore ? (
          <>
            <div style={{ display: "flex", gap: 10, alignItems: "baseline", justifyContent: "center" }}>
              <span
                className="matchup-score"
                style={{ color: homeWin ? "var(--gold)" : "var(--text-dim)" }}
              >
                {ptsHome}
              </span>
              <span style={{ color: "var(--text-muted)", fontSize: 12 }}>—</span>
              <span
                className="matchup-score"
                style={{ color: awayWin ? "var(--gold)" : "var(--text-dim)" }}
              >
                {ptsAway}
              </span>
            </div>
            <div style={{ fontSize: 9, color: "var(--text-muted)", letterSpacing: "0.1em", marginTop: 2 }}>
              FINAL
            </div>
          </>
        ) : (
          <div className="matchup-vs">VS</div>
        )}
      </div>

      {/* Away */}
      <div style={{ textAlign: "right" }}>
        <div className="matchup-team" style={{ color: awayWin ? "var(--gold)" : "var(--text)" }}>
          {away}
        </div>
        {hasScore && (
          <div style={{ fontSize: 11, color: "var(--text-dim)", marginTop: 2 }}>
            {awayWin ? "✓ WIN" : homeWin ? "LOSS" : "TIE"}
          </div>
        )}
      </div>
    </div>
  );
}
